import { observable, makeObservable } from "mobx";

class UserStore {
  @observable
  user = {
    fromAdmin: false,
  };

  constructor() {
    makeObservable(this);
  }

  init() {
    if (luvit.GetQueryString("fromAdmin") === "1") {
      if (window.top) {
        window.top.fromAdmin = 1;
        //Hack to persistently store information across route changes when inside of an iframe
      }
      this.user.fromAdmin = true;
    } else if (
      window.top &&
      window.top.fromAdmin &&
      window.top.fromAdmin === 1
    ) {
      //if in iframe check if fromAdmin has been set in the parent-page
      this.user.fromAdmin = true;
    }
  }
  setFromAdmin(isFromAdmin) {
    this.user.fromAdmin = isFromAdmin;
  }
}

export default new UserStore();
